<template>
  <div class="home">
      <div class="bg-black">
          <div class="container show-on-scroll mx-auto h-full relative z-10">
            <nav class="flex items-center justify-between flex-wrap py-4 px-6 lg:pt-10">
                <div class="flex-1 lg:order-2">
                    <img src="/images/logo.png" alt="Aik Hock Tyre & Battery Services" class="h-10 lg:h-16 lg:mx-auto">
                </div>
                <div class="flex-none mr-6 lg:order-1 lg:flex-1">
                    <div class="flex items-center text-white text-lg">
                        <img src="/images/call-us-icon.png" alt="Call Us" class="h-10 mr-2 lg:h-12"> <span class="hidden md:block">9871 1616</span>
                    </div>
                </div>
                <div class="flex-none lg:order-3 lg:flex-1">
                    <div class="flex items-center text-white text-lg lg:justify-end">
                        <img src="/images/whatsapp-icon.png" alt="Whats App" class="h-10 mr-2 lg:h-12">
                        <div class="hidden md:block leading-none">
                            <div class="text-xs mb-1">WhatsApp</div>
                            <div>9871 1616</div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
      </div>
      <div class="py-20 px-4 text-center">
        <p>Page Not Found</p>
      </div>
      <Footer />
  </div>
</template>

<script>
  // @ is an alias to /src
    import Footer from '@/components/Footer.vue'

    export default {
        name: 'Home',
        components: {
            Footer
        }
    }
  </script
</script>
